export const TRAINER_NAV_ITEM = { id: 'trainer', to: '/app', label: 'Trainer' };
export const SIMULATOR_NAV_ITEM = { id: 'simulator', to: '/simulator', label: 'Simulator' };
export const STATS_NAV_ITEM = { id: 'stats', to: '/dashboard', label: 'Stats' };
export const ACCOUNT_NAV_ITEM = { id: 'account', to: '/profile', label: 'Account' };

export const TOOL_NAV_ITEMS = [TRAINER_NAV_ITEM, SIMULATOR_NAV_ITEM];
export const ACCOUNT_NAV_ITEMS = [STATS_NAV_ITEM, ACCOUNT_NAV_ITEM];
